import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Box, Button, IconButton, TableRow, Tooltip } from "@mui/material";
import React from "react";
import { iDataUserSuscription } from "../../../../interfaces/SuperAdmin/Pages/iDataUserSuscription";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../../utils/dateFunctions";

interface Props {
  sub: iDataUserSuscription;
  index: number;
  assignToDeleteSuscr: (suscrId: string) => void;
}

const RowSuscriptionInUser: React.FC<Props> = ({
  sub,
  index,
  assignToDeleteSuscr,
}) => {
  return (
    <TableRow>
      <StyledTableCell align="center">{index}</StyledTableCell>
      <StyledTableCell align="center">
        <Box
          sx={{
            py: 1.5,
            px: 2,
            borderRadius: "8px",
            backgroundColor: "#F9BA3280",
            color: "#6A93A8",
            textAlign: "center",
            fontWeight: 700,
            fontSize: 16,
          }}
        >
          {sub.plan}
        </Box>
      </StyledTableCell>
      <StyledTableCell align="center">
        {formatFechaWithHour(sub.fecha_asignacion)}
      </StyledTableCell>
      <StyledTableCell align="center">
        {formatFechaWithHour(sub.fecha_fin)}
      </StyledTableCell>
      <StyledTableCell align="center">{sub.creditos_gastados}</StyledTableCell>
      <StyledTableCell align="center">{sub.estado}</StyledTableCell>
      <StyledTableCell align="center">
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => assignToDeleteSuscr(sub.id_suscripcion)}
        >
          <Tooltip title="Eliminar suscripción">
            <IconButton aria-label="delete" sx={{ color: "#336B87" }}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </TableRow>
  );
};

export default RowSuscriptionInUser;
